import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
export function Hero() {
  const scrollToReport = () => {
    const element = document.getElementById('deal-report');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-252" data-mp="4mru70n4vzl8">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-253" data-mp="xano5xlbjdeb">
        <img src="https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?q=80&w=2940&auto=format&fit=crop" alt="Luxury architecture" className="w-full h-full object-cover" data-id="element-254" data-mp="xbpbb0flzqce" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/95 via-navy/90 to-navy/95" data-id="element-255" data-mp="nbyj55eitnfh"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20" data-id="element-256" data-mp="382p73hcojln9">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-257" data-mp="3j8ivmv0mo8sl">
          <div className="flex items-center justify-center mb-6" data-id="element-258" data-mp="399jq3lb5st9t">
            <TrendingUpIcon className="text-gold mr-3" size={32} data-id="element-259" data-mp="3e8wismopoukb" />
            <span className="text-gold text-sm font-semibold tracking-wider uppercase" data-id="element-260" data-mp="3eb91x367hayy">
              Institutional-Grade Deal Flow
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-261" data-mp="35aausc0h0nc5">
            Curated Real Estate Deal Flow.
            <br data-id="element-262" data-mp="2viojkfo4uo9e" />
            <span className="text-gold" data-id="element-263" data-mp="2vi56bc9fgo1p">Cabo San Lucas.</span>
          </h1>

          <p className="text-xl sm:text-2xl text-white/90 mb-12 max-w-4xl mx-auto leading-relaxed" data-id="element-264" data-mp="2hjf7ns6ymgb8">
            Cabo Deal Flow is a curated, independently analyzed real estate
            investment resource. Every deal listed here has been vetted,
            researched, and backed by quantified data — rental yield, cash flow,
            ROI, equity upside. This is not a listing site.
            <span className="text-gold font-semibold" data-id="element-265" data-mp="ic889f9986xu"> This is deal flow.</span>
          </p>

          <motion.button onClick={scrollToReport} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-gold hover:bg-gold-light text-navy px-10 py-4 rounded-lg font-bold text-lg transition-colors shadow-xl" data-id="element-266" data-mp="dd5cymj2tf32">
            Access the Deal Report
          </motion.button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2" data-id="element-267" data-mp="x0l3ub4fjnrt">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2" data-id="element-268" data-mp="1xacf521xbhsp">
          <motion.div animate={{
          y: [0, 12, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="w-1.5 h-1.5 bg-gold rounded-full" data-id="element-269" data-mp="21bpjf7pdbcxi" />
        </div>
      </motion.div>
    </section>;
}